import { MenuDivider, MenuItem } from '@lokalise/louis';
import { Fragment } from 'react';

import type { DropdownItem } from '../../../../types/navigation';

export const DropdownContent = ({ items }: { items: DropdownItem[][] }) => (
    <>
        {items.map((item, index) => (
            <Fragment key={item[0].label}>
                {!!index && item.some((value) => value.visible) && <MenuDivider />}
                {item
                    .filter(({ visible }) => visible)
                    .map(({ link, label, onClick }) => (
                        <MenuItem key={label} href={link || '#'} aria-label={label} onClick={onClick}>
                            {label}
                        </MenuItem>
                    ))}
            </Fragment>
        ))}
    </>
);

export default DropdownContent;
